import { render, staticRenderFns } from "./sonTopic.vue?vue&type=template&id=97e26410&scoped=true&"
import script from "./sonTopic.vue?vue&type=script&lang=js&"
export * from "./sonTopic.vue?vue&type=script&lang=js&"
import style0 from "./sonTopic.vue?vue&type=style&index=0&id=97e26410&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e26410",
  null
  
)

export default component.exports